import { usePrevious } from "../../hooks";
import { useEffect } from "react";
import isEqual from "react-fast-compare";
import { ecommerceTrackingAspect } from "../../domain/google-tag-manager/ecommerce-tracking-aspect";
import { LoadingStateWithIdle } from "../../domain/data-layer/loading-state-with-idle";
import { PlpSearchResponse } from "@swo/storefront";

export function useProductImpressions(
  facetsQuery: { [key: string]: string },
  storefrontResponse: LoadingStateWithIdle<{ result: PlpSearchResponse }>,
  context: { category: string; segment: string },
) {
  const previousStorefrontResponse = usePrevious(storefrontResponse);

  useEffect(() => {
    if (
      Object.keys(facetsQuery).length > 0 &&
      storefrontResponse.__tag === "loaded" &&
      (!previousStorefrontResponse ||
        previousStorefrontResponse.__tag !== "loaded" ||
        (previousStorefrontResponse.__tag === "loaded" &&
          !isEqual(previousStorefrontResponse.data.result.products, storefrontResponse.data.result.products)))
    ) {
      const price = storefrontResponse.data.result.products
        .map(p => p.lowestPrice)
        .find(price => typeof price !== "undefined");

      if (price) {
        ecommerceTrackingAspect
          .productImpressions(
            price.currencyCode,
            storefrontResponse.data.result.products.map(p => {
              return {
                name: p.name,
                category: context.category,
                dimension10: context.segment,
              };
            }),
          )
          .push();
      }
    }
  }, [storefrontResponse]);
}
